import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { BoxProps } from '@dtx-company/shared-components/src'
import { DropdownNumbers, NumberDropdownBox, NumberDropdownMenu } from './style'
import { FC, useState } from 'react'
import { Icon } from '@dtx-company/shared-components/src/components/atoms/Icon/index'
import { Spacer } from '@dtx-company/shared-components/src/components/atoms/Spacer/index'
import { Text } from '@dtx-company/shared-components/src/components/atoms/Text/index'
import { arrowDown, arrowUp } from '@app/code/src/assets'

export const NumberDropdown: FC<
  {
    minNumber?: number
    maxNumber: number
    currentNumber: number
    setNumber: (i: number) => void
  } & BoxProps
> = ({ minNumber = 0, maxNumber, currentNumber, setNumber, ...rest }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  return (
    <Box position={'relative'} {...rest}>
      <NumberDropdownBox>
        <Text variant={'body/medium'}>{currentNumber}</Text>
        <Spacer mr={'4px'} />
        <Box
          cursor={'pointer'}
          onClick={() => {
            setIsDropdownOpen(prev => !prev)
          }}
        >
          <Icon src={isDropdownOpen ? arrowUp : arrowDown} width={'12px'} />
        </Box>
      </NumberDropdownBox>
      {isDropdownOpen && (
        <NumberDropdownMenu>
          {[...Array(maxNumber + 1)].map((_, i) => {
            return (
              i >= minNumber && (
                <DropdownNumbers
                  variant={'body/medium'}
                  cursor="pointer"
                  key={i}
                  onClick={() => {
                    setNumber(i)
                    setIsDropdownOpen(false)
                  }}
                >
                  {i}
                </DropdownNumbers>
              )
            )
          })}
        </NumberDropdownMenu>
      )}
    </Box>
  )
}
